import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';




export default function GSTable({rows,Month1,Month2,Month3}) {
  React.useEffect(() => {
  
  }, []);
 
  
  
  const columns = [
    { field: "id", headerName: "ID", width: 40, hide: true },
    {
      field: 'teamcode',
      headerName: 'Team Code',
      width: 90,
      sortable: false,
      align:"left",
      hide: true
    },
    {
      field: 'rbmname',
      headerName: 'RBM Name',
      width: 200,
      align:"left",
      sortable: false,
    },
    {
      field: 'brand',
      headerName: 'Brand',
      width: 160,
      align:"left",
      sortable: false,
    },
    {
      field: 'm1_adjusted_budget_value',
      headerName:`Adj.Bud V(${Month1})`,
      width: 150,
      align:"center",
      renderCell: (params, rowId) => {
        const value=(params.row.m1_adjusted_budget_value).toFixed(2)
        return (
          <p title={params.row.m1_adjusted_budget_value} style={{align:"center"}}>
            {value}
          </p>
        );
      },
      align:"center",

    },
    {
      field: 'm2_adjusted_budget_value',
      headerName: `Adj.Bud V(${Month2})`,
      width: 150,
      sortable: true,
      align:"center",
      renderCell: (params, rowId) => {
        const value=(params.row.m2_adjusted_budget_value).toFixed(2)
        return (
          <p title={params.row.m2_adjusted_budget_value}  style={{align:"center"}}>
            {value}
          </p>
        );
      },
      
    },
    {
      field: 'm3_adjusted_budget_value',
      headerName:`Adj.Bud V(${Month3})`,
      width: 150,
      align:"center",
      sortable: true,
      renderCell: (params, rowId) => {
        const value=(params.row.m3_adjusted_budget_value).toFixed(2)
        return (
          <p title={params.row.m3_adjusted_budget_value}  style={{align:"center"}}>
            {value}
          </p>
        );
      },
    },
    {
      field:'lq_m1_v_sales',
      headerName:`Sales V (${Month1})`,
      width: 90,
      align:"center",
      sortable: true,

      renderCell: (params, rowId) => {
        const value=(params.row.lq_m1_v_sales).toFixed(1)
        return (
          <p title={params.row.lq_m1_v_sales}  style={{align:"center"}}>
            {value}
          </p>
        );
      },
    },
    {
      field: 'lq_m2_v_sales',
      headerName: `Sales V (${Month2})`,
      width: 90,
      align:"center",
      sortable: true,
      renderCell: (params, rowId) => {
        const value=(params.row.lq_m2_v_sales).toFixed(1)
        return (
          <p title={params.row.lq_m2_v_sales} style={{align:"center"}}>
            {value}
          </p>
        );
      },
    },
    {
      field: 'lq_m3_v_sales',
      headerName:`Sales V (${Month3})`,
      width: 90,
      align:"center",
      sortable: true,
      renderCell: (params, rowId) => {
        const value=(params.row.lq_m3_v_sales).toFixed(1)
        return (
          <p title={params.row.lq_m3_v_sales}  style={{align:"center"}}>
            {value}
          </p>
        );
      },
    },
    {
      field: 'm1_growthsummary',
      headerName:  `% Gr (${Month1})`,
      width: 150,
      sortable: true,
      align:"center",

      renderCell: (params, rowId) => {
        const value=((params.row.m1_growthsummary)*100).toFixed(1)
  
        return (
          <p title={params.row.m1_growthsummary}  style={{align:"center"}}>
            {value}
          </p>
        );
      },
    },
    {
      field: 'm2_growthsummary',
      headerName:  `% Gr (${Month2})`,
      width: 150,
      sortable: true,
      align:"center",
      renderCell: (params, rowId) => {
        const value=((params.row.m2_growthsummary)*100).toFixed(1)
  
        return (
          <p title={params.row.m2_growthsummary}  style={{align:"center"}}>
            {value}
          </p>
        );
      },
    },
    {
      field: 'm3_growthsummary',
      headerName: `% Gr (${Month3})`,
      width: 150,
      sortable: true,
      align:"center",
      renderCell: (params, rowId) => {
        const value=((params.row.m3_growthsummary)*100).toFixed(1)
        return (
          <p title={params.row.m3_growthsummary} style={{align:"center"}}>
            {value}
          </p>
        );
      },
    },
  ];
  return (
    <div style={{ height: 480, width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={15}
        rowsPerPageOptions={[15]}
        density='compact'
      />
    </div>
  );
}
